import { useTranslation, Trans } from "react-i18next";

import { Message, Spacer, Link } from "@aviary";
import { sharedRoutes } from "@shared/data/sharedRoutes";
import { useSharedGlobalConfig } from "@shared/hooks/useSharedGlobalConfig/useSharedGlobalConfig";
import { l } from "@unauthenticated/shared/locales/i18n";

import * as styles from "./AuthenticationLockedMessage.styles";

const AuthenticationLockedMessage = () => {
  const { t } = useTranslation();
  const { isEmerson } = useSharedGlobalConfig();

  const supportLink = isEmerson
    ? sharedRoutes.external.emerson.contactSupport
    : sharedRoutes.external.contactSupport;

  return (
    <div css={styles.textLeft}>
      <Message titleContent={t(l.signIn.errors.authenticationLockedTitle)} isColor="danger">
        <Trans
          i18nKey={l.signIn.errors.authenticationLockedMessage}
          components={{
            Link: <Link href={supportLink} />,
          }}
        />
      </Message>
      <Spacer height="one" />
    </div>
  );
};

export { AuthenticationLockedMessage };
